import { useNavigate } from 'react-router-dom'
import useAnnouncements from '../../hooks/announcements/useAnnouncements'
import { useChallengeId } from '../../hooks/challenge/useChallengeId'
import { useEvents } from '../../hooks/events/useEvents'
import { useUser } from '../../hooks/user/useUser'
import { useConfig } from '../../hooks/util/useConfig'
import { ScreenPath } from '../../navigation'
import AnnouncementBanner from '../../ui/home/AnnouncementBanner'
import AppShell from '../../ui/layout/AppShell'
import styles from '../../ui/onboarding/GuardView.module.css'
import Button from '../../ui/primitives/Button'
import CountdownTimer from '../../ui/primitives/CountdownTimer'
import EventCardContainer from '../events/EventCardContainer'
import PageHeaderContainer from '../layout/PageHeaderContainer'

interface EventRequiredViewProps {
  children: JSX.Element
}

export default function EventRequiredView({ children }: EventRequiredViewProps) {
  const navigate = useNavigate()
  const { data: config } = useConfig()
  const { data: events } = useEvents()
  const { data: user } = useUser()
  const challengeId = useChallengeId()
  const { data: announcements } = useAnnouncements(challengeId)
  const bypassEventCheck = process.env.REACT_APP_BYPASS_EVENT_CHECK === 'true'

  function goToTeam() {
    navigate(ScreenPath.team)
  }

  if (bypassEventCheck || user?.isAdmin) return <>{children}</>
  if (config?.hasStarted()) return <>{children}</>

  const topAnnouncement = [...(announcements ?? [])].sort(
    (a, b) => b.createdAt.getTime() - a.createdAt.getTime(),
  )[0]

  return (
    <AppShell header={<PageHeaderContainer />}>
      {topAnnouncement && (
        <AnnouncementBanner
          id={topAnnouncement.id}
          title={topAnnouncement.title}
          link={topAnnouncement.link}
          videoUrl={topAnnouncement.videoUrl}
        />
      )}
      <div className={styles.eventWrap}>
        <h1 className={styles.title}>Challenge starts in</h1>
        {config?.startDate && <CountdownTimer targetDate={config.startDate} />}
        <Button onClick={goToTeam}>See my team</Button>
        {events && events.length > 0 && (
          <div className={styles.eventList}>
            {events.map((event) => (
              <EventCardContainer key={event.id} event={event} />
            ))}
          </div>
        )}
      </div>
    </AppShell>
  )
}
